












import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'


@Component({
  components: {
  },
})
export default class Email extends Mixins(MainMixin) {
  tabs = [{ title: 'View', value: 'view' }, { title: 'New Board', value: 'new' }, { title: 'Edit Board', value: 'edit' }]
}
